module.exports = __webpack_public_path__ + "media/review-and-comment.e6ebc34f.mp4";